import styled from 'styled-components';

export const Root = styled.div`
  @media (min-width: ${(props) => props.theme.device.mobile}) {
    padding-bottom: 5px;
  }
`;
